import React from "react";

const FeaturedText = ({ title, desc, link, repo, techStack }) => {
  return (
    <div className="project__content">
      <h3 className="project__title">{title}</h3>
      <div className="textContainer">
        <div className="project__description">
          <p>{desc}</p>
        </div>
        <div className="project__details">
          {link && (
            <a href={link} target="_blank" rel="noopener noreferrer">
              <button>View Demo</button>
            </a>
          )}
          <a href={repo} target="_blank" rel="noopener noreferrer">
            <button>View Code</button>
          </a>
          <ul className="project__techstack">
            {techStack ? techStack.map((tech) => <li>{tech}</li>) : "tecgstacl"}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FeaturedText;
